package com.cybersoftsolution.cybersoftsolutionweb.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.indicators.LoadingIndicator
import com.cybersoftsolution.cybersoftsolutionweb.components.indicators.OverlayLoadingIndicator
import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.SidePanel
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.sidePanelCollapsedHeight
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.sidePanelInternalWidth
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.window
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.plus
import org.jetbrains.compose.web.css.px


var screenWidthFull = window.innerWidth
var screenHeightFull = window.innerHeight

@Composable
inline fun AdminPageLayout(
    isLoading: Boolean = false,
    crossinline onScreenWidthChange: (Int) -> Unit = {},
    crossinline content: @Composable () -> Unit
){
    val breakpoint = rememberBreakpoint()

    var sidePanelInternalIsOpen by remember { mutableStateOf(true) }

    var screenWidth by remember{ mutableStateOf(screenWidthFull- 10) }
    var screenHeight by remember{ mutableStateOf(screenHeightFull) }



        LaunchedEffect(Unit) {

            window.onresize = {
                window.innerWidth.also {
                    screenWidthFull = it
                    screenWidth = screenWidthFull - 10

                }
                onScreenWidthChange(screenWidth)

                window.innerHeight.also {
                    screenHeightFull = it
                    screenHeight = screenHeightFull
                }
            }

        }

        Box(
            Modifier
                .fillMaxSize()
            ,
            contentAlignment = Alignment.TopStart
        ) {

            if (isLoading) {
                OverlayLoadingIndicator()
            }


            SidePanel(sidePanelInternalIsCurrentlyOpen = { sidePanelInternalIsOpen = it } )

            Box(
                Modifier
//                    .fillMaxSize()
//                    .width(screenWidth.px)
//                    .transition(
//                        Transition.of(
//                            property = "width",
//                            duration = 500.ms,
//                            timingFunction = null,
//                            delay = null
//                        )
//
//                    )
                    .transition(
                        Transition.of(
                            property = "padding",
                            duration = 500.ms,
                            timingFunction = null,
                            delay = 500.ms
                        )

                    )
                    .width(
                        100.percent
//                        if (breakpoint >= Breakpoint.MD) {
//
//                            if (sidePanelInternalIsOpen) {
//                                screenWidth.px - sidePanelInternalWidth
//                            } else {
//                                100.percent
//                            }
//
//
//                        } else {
//                            100.percent
//                        }
                    )
//                    .fillMaxHeight()
//                    .padding(
//                        left = if (breakpoint > Breakpoint.SM) sidePanelInternalWidth else 0.px,
//                        top = (sidePanelCollapsedHeight + 38.px )
//                    )
//                    .margin(
                    .padding(
                        left = if (breakpoint >= Breakpoint.MD) {
                            if (sidePanelInternalIsOpen) {
                                sidePanelInternalWidth
                            } else {
                                0.px
                            }

                        } else {
                            0.px
                        },


                        top = (sidePanelCollapsedHeight + 38.px)
                    )
//                    .backgroundColor(Theme.LightGray.rgb)

                ,
                contentAlignment = Alignment.TopCenter,


                ) {

//                Text(screenWidth.px.toString()+"/n"+screenHeight.px.toString())

                content()
            }



        }

    }